import { render, staticRenderFns } from "./hospitalTotal.vue?vue&type=template&id=32b33a08&scoped=true&"
import script from "./hospitalTotal.vue?vue&type=script&lang=js&"
export * from "./hospitalTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b33a08",
  null
  
)

export default component.exports